/**
 * PageHeader Component
 * Pure presentation component for page headers.
 */

import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  description,
  actions,
  className = '',
}: PageHeaderProps) {
  const baseClasses = 'flex items-center justify-between py-[var(--space-6)] border-b border-[var(--surface-border-subtle)]';
  const classes = `${baseClasses} ${className}`.trim();

  return (
    <header className={classes}>
      <div>
        <h1 className="text-[var(--text-3xl)] font-bold text-[var(--surface-text-primary)]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-[var(--space-1)] text-[var(--text-base)] text-[var(--surface-text-secondary)]">
            {subtitle}
          </p>
        )}
        {description && (
          <p className="mt-[var(--space-1)] text-[var(--text-base)] text-[var(--surface-text-secondary)]">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-[var(--space-2)]">{actions}</div>}
    </header>
  );
}
